// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createOrder = /* GraphQL */ `mutation CreateOrder(
  $input: CreateOrderInput!
  $condition: ModelOrderConditionInput
) {
  createOrder(input: $input, condition: $condition) {
    id
    createdAt
    user {
      id
      email
      username
      emailVerified
      identityId
      credits
      boughtCredits
      creditPurchases {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          creditAmount
          checkoutSessionId
          paymentIntentId
          owner
          updatedAt
          userCreditPurchasesId
          __typename
        }
        nextToken
        __typename
      }
      orders {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      owner
      createdAt
      updatedAt
      __typename
    }
    stripeCustomerId
    invoiceNumber
    invoiceId
    receiptNumber
    cart {
      id
      createdAt
      order {
        id
        createdAt
        user {
          id
          email
          username
          emailVerified
          identityId
          credits
          boughtCredits
          creditPurchases {
            nextToken
            __typename
          }
          orders {
            nextToken
            __typename
          }
          stripeCustomerId
          owner
          createdAt
          updatedAt
          __typename
        }
        stripeCustomerId
        invoiceNumber
        invoiceId
        receiptNumber
        cart {
          id
          createdAt
          order {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          artOrders {
            nextToken
            __typename
          }
          email
          status
          cost_total
          updatedAt
          cartOrderId
          __typename
        }
        email
        status
        cost_total
        cost_taxes
        cost_shipping
        couponId
        coupon_amount_off
        coupon_name
        discountId
        discount_amount
        promotionID
        promotion_code
        fulfillment_tracking_id
        fulfillment_method
        fulfillment_status
        fulfillment_createdAt
        fulfillment_updatedAt
        fulfillment_completedAt
        billing_name
        billing_address
        billing_address2
        billing_city
        billing_state
        billing_zip
        billing_country
        shipping_name
        shipping_address
        shipping_address2
        shipping_city
        shipping_state
        shipping_zip
        shipping_country
        shipping_phone
        notes
        vendor
        order_source
        currency
        cancel
        updatedAt
        userOrdersId
        orderCartId
        __typename
      }
      artOrders {
        items {
          id
          createdAt
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          orderID
          art {
            id
            userId
            createdAt
            title
            inputImage
            prompt
            revisedPrompt
            subject
            subjectText
            subOption
            styles
            stylesText
            color
            colorText
            medium
            mediumText
            model
            feeling
            feelingText
            like
            approve
            deleted
            updatedAt
            __typename
          }
          email
          file {
            bucket
            region
            key
            __typename
          }
          dpi
          length
          width
          resolution_length
          resolution_width
          paper
          frame
          moulding
          moulding_finish
          mount
          total
          tax
          updatedAt
          cartArtOrdersId
          artOrderArtId
          __typename
        }
        nextToken
        __typename
      }
      email
      status
      cost_total
      updatedAt
      cartOrderId
      __typename
    }
    email
    status
    cost_total
    cost_taxes
    cost_shipping
    couponId
    coupon_amount_off
    coupon_name
    discountId
    discount_amount
    promotionID
    promotion_code
    fulfillment_tracking_id
    fulfillment_method
    fulfillment_status
    fulfillment_createdAt
    fulfillment_updatedAt
    fulfillment_completedAt
    billing_name
    billing_address
    billing_address2
    billing_city
    billing_state
    billing_zip
    billing_country
    shipping_name
    shipping_address
    shipping_address2
    shipping_city
    shipping_state
    shipping_zip
    shipping_country
    shipping_phone
    notes
    vendor
    order_source
    currency
    cancel
    updatedAt
    userOrdersId
    orderCartId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOrderMutationVariables,
  APITypes.CreateOrderMutation
>;
export const updateOrder = /* GraphQL */ `mutation UpdateOrder(
  $input: UpdateOrderInput!
  $condition: ModelOrderConditionInput
) {
  updateOrder(input: $input, condition: $condition) {
    id
    createdAt
    user {
      id
      email
      username
      emailVerified
      identityId
      credits
      boughtCredits
      creditPurchases {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          creditAmount
          checkoutSessionId
          paymentIntentId
          owner
          updatedAt
          userCreditPurchasesId
          __typename
        }
        nextToken
        __typename
      }
      orders {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      owner
      createdAt
      updatedAt
      __typename
    }
    stripeCustomerId
    invoiceNumber
    invoiceId
    receiptNumber
    cart {
      id
      createdAt
      order {
        id
        createdAt
        user {
          id
          email
          username
          emailVerified
          identityId
          credits
          boughtCredits
          creditPurchases {
            nextToken
            __typename
          }
          orders {
            nextToken
            __typename
          }
          stripeCustomerId
          owner
          createdAt
          updatedAt
          __typename
        }
        stripeCustomerId
        invoiceNumber
        invoiceId
        receiptNumber
        cart {
          id
          createdAt
          order {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          artOrders {
            nextToken
            __typename
          }
          email
          status
          cost_total
          updatedAt
          cartOrderId
          __typename
        }
        email
        status
        cost_total
        cost_taxes
        cost_shipping
        couponId
        coupon_amount_off
        coupon_name
        discountId
        discount_amount
        promotionID
        promotion_code
        fulfillment_tracking_id
        fulfillment_method
        fulfillment_status
        fulfillment_createdAt
        fulfillment_updatedAt
        fulfillment_completedAt
        billing_name
        billing_address
        billing_address2
        billing_city
        billing_state
        billing_zip
        billing_country
        shipping_name
        shipping_address
        shipping_address2
        shipping_city
        shipping_state
        shipping_zip
        shipping_country
        shipping_phone
        notes
        vendor
        order_source
        currency
        cancel
        updatedAt
        userOrdersId
        orderCartId
        __typename
      }
      artOrders {
        items {
          id
          createdAt
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          orderID
          art {
            id
            userId
            createdAt
            title
            inputImage
            prompt
            revisedPrompt
            subject
            subjectText
            subOption
            styles
            stylesText
            color
            colorText
            medium
            mediumText
            model
            feeling
            feelingText
            like
            approve
            deleted
            updatedAt
            __typename
          }
          email
          file {
            bucket
            region
            key
            __typename
          }
          dpi
          length
          width
          resolution_length
          resolution_width
          paper
          frame
          moulding
          moulding_finish
          mount
          total
          tax
          updatedAt
          cartArtOrdersId
          artOrderArtId
          __typename
        }
        nextToken
        __typename
      }
      email
      status
      cost_total
      updatedAt
      cartOrderId
      __typename
    }
    email
    status
    cost_total
    cost_taxes
    cost_shipping
    couponId
    coupon_amount_off
    coupon_name
    discountId
    discount_amount
    promotionID
    promotion_code
    fulfillment_tracking_id
    fulfillment_method
    fulfillment_status
    fulfillment_createdAt
    fulfillment_updatedAt
    fulfillment_completedAt
    billing_name
    billing_address
    billing_address2
    billing_city
    billing_state
    billing_zip
    billing_country
    shipping_name
    shipping_address
    shipping_address2
    shipping_city
    shipping_state
    shipping_zip
    shipping_country
    shipping_phone
    notes
    vendor
    order_source
    currency
    cancel
    updatedAt
    userOrdersId
    orderCartId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateOrderMutationVariables,
  APITypes.UpdateOrderMutation
>;
export const deleteOrder = /* GraphQL */ `mutation DeleteOrder(
  $input: DeleteOrderInput!
  $condition: ModelOrderConditionInput
) {
  deleteOrder(input: $input, condition: $condition) {
    id
    createdAt
    user {
      id
      email
      username
      emailVerified
      identityId
      credits
      boughtCredits
      creditPurchases {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          creditAmount
          checkoutSessionId
          paymentIntentId
          owner
          updatedAt
          userCreditPurchasesId
          __typename
        }
        nextToken
        __typename
      }
      orders {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      owner
      createdAt
      updatedAt
      __typename
    }
    stripeCustomerId
    invoiceNumber
    invoiceId
    receiptNumber
    cart {
      id
      createdAt
      order {
        id
        createdAt
        user {
          id
          email
          username
          emailVerified
          identityId
          credits
          boughtCredits
          creditPurchases {
            nextToken
            __typename
          }
          orders {
            nextToken
            __typename
          }
          stripeCustomerId
          owner
          createdAt
          updatedAt
          __typename
        }
        stripeCustomerId
        invoiceNumber
        invoiceId
        receiptNumber
        cart {
          id
          createdAt
          order {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          artOrders {
            nextToken
            __typename
          }
          email
          status
          cost_total
          updatedAt
          cartOrderId
          __typename
        }
        email
        status
        cost_total
        cost_taxes
        cost_shipping
        couponId
        coupon_amount_off
        coupon_name
        discountId
        discount_amount
        promotionID
        promotion_code
        fulfillment_tracking_id
        fulfillment_method
        fulfillment_status
        fulfillment_createdAt
        fulfillment_updatedAt
        fulfillment_completedAt
        billing_name
        billing_address
        billing_address2
        billing_city
        billing_state
        billing_zip
        billing_country
        shipping_name
        shipping_address
        shipping_address2
        shipping_city
        shipping_state
        shipping_zip
        shipping_country
        shipping_phone
        notes
        vendor
        order_source
        currency
        cancel
        updatedAt
        userOrdersId
        orderCartId
        __typename
      }
      artOrders {
        items {
          id
          createdAt
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          orderID
          art {
            id
            userId
            createdAt
            title
            inputImage
            prompt
            revisedPrompt
            subject
            subjectText
            subOption
            styles
            stylesText
            color
            colorText
            medium
            mediumText
            model
            feeling
            feelingText
            like
            approve
            deleted
            updatedAt
            __typename
          }
          email
          file {
            bucket
            region
            key
            __typename
          }
          dpi
          length
          width
          resolution_length
          resolution_width
          paper
          frame
          moulding
          moulding_finish
          mount
          total
          tax
          updatedAt
          cartArtOrdersId
          artOrderArtId
          __typename
        }
        nextToken
        __typename
      }
      email
      status
      cost_total
      updatedAt
      cartOrderId
      __typename
    }
    email
    status
    cost_total
    cost_taxes
    cost_shipping
    couponId
    coupon_amount_off
    coupon_name
    discountId
    discount_amount
    promotionID
    promotion_code
    fulfillment_tracking_id
    fulfillment_method
    fulfillment_status
    fulfillment_createdAt
    fulfillment_updatedAt
    fulfillment_completedAt
    billing_name
    billing_address
    billing_address2
    billing_city
    billing_state
    billing_zip
    billing_country
    shipping_name
    shipping_address
    shipping_address2
    shipping_city
    shipping_state
    shipping_zip
    shipping_country
    shipping_phone
    notes
    vendor
    order_source
    currency
    cancel
    updatedAt
    userOrdersId
    orderCartId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteOrderMutationVariables,
  APITypes.DeleteOrderMutation
>;
export const createCart = /* GraphQL */ `mutation CreateCart(
  $input: CreateCartInput!
  $condition: ModelCartConditionInput
) {
  createCart(input: $input, condition: $condition) {
    id
    createdAt
    order {
      id
      createdAt
      user {
        id
        email
        username
        emailVerified
        identityId
        credits
        boughtCredits
        creditPurchases {
          items {
            id
            createdAt
            creditAmount
            checkoutSessionId
            paymentIntentId
            owner
            updatedAt
            userCreditPurchasesId
            __typename
          }
          nextToken
          __typename
        }
        orders {
          items {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          nextToken
          __typename
        }
        stripeCustomerId
        owner
        createdAt
        updatedAt
        __typename
      }
      stripeCustomerId
      invoiceNumber
      invoiceId
      receiptNumber
      cart {
        id
        createdAt
        order {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        artOrders {
          items {
            id
            createdAt
            orderID
            email
            dpi
            length
            width
            resolution_length
            resolution_width
            paper
            frame
            moulding
            moulding_finish
            mount
            total
            tax
            updatedAt
            cartArtOrdersId
            artOrderArtId
            __typename
          }
          nextToken
          __typename
        }
        email
        status
        cost_total
        updatedAt
        cartOrderId
        __typename
      }
      email
      status
      cost_total
      cost_taxes
      cost_shipping
      couponId
      coupon_amount_off
      coupon_name
      discountId
      discount_amount
      promotionID
      promotion_code
      fulfillment_tracking_id
      fulfillment_method
      fulfillment_status
      fulfillment_createdAt
      fulfillment_updatedAt
      fulfillment_completedAt
      billing_name
      billing_address
      billing_address2
      billing_city
      billing_state
      billing_zip
      billing_country
      shipping_name
      shipping_address
      shipping_address2
      shipping_city
      shipping_state
      shipping_zip
      shipping_country
      shipping_phone
      notes
      vendor
      order_source
      currency
      cancel
      updatedAt
      userOrdersId
      orderCartId
      __typename
    }
    artOrders {
      items {
        id
        createdAt
        cart {
          id
          createdAt
          order {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          artOrders {
            nextToken
            __typename
          }
          email
          status
          cost_total
          updatedAt
          cartOrderId
          __typename
        }
        orderID
        art {
          id
          userId
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          title
          inputImage
          s3Image {
            bucket
            region
            key
            __typename
          }
          prompt
          revisedPrompt
          subject
          subjectText
          subOption
          styles
          stylesText
          color
          colorText
          medium
          mediumText
          model
          feeling
          feelingText
          like
          approve
          deleted
          updatedAt
          __typename
        }
        email
        file {
          bucket
          region
          key
          __typename
        }
        dpi
        length
        width
        resolution_length
        resolution_width
        paper
        frame
        moulding
        moulding_finish
        mount
        total
        tax
        updatedAt
        cartArtOrdersId
        artOrderArtId
        __typename
      }
      nextToken
      __typename
    }
    email
    status
    cost_total
    updatedAt
    cartOrderId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCartMutationVariables,
  APITypes.CreateCartMutation
>;
export const updateCart = /* GraphQL */ `mutation UpdateCart(
  $input: UpdateCartInput!
  $condition: ModelCartConditionInput
) {
  updateCart(input: $input, condition: $condition) {
    id
    createdAt
    order {
      id
      createdAt
      user {
        id
        email
        username
        emailVerified
        identityId
        credits
        boughtCredits
        creditPurchases {
          items {
            id
            createdAt
            creditAmount
            checkoutSessionId
            paymentIntentId
            owner
            updatedAt
            userCreditPurchasesId
            __typename
          }
          nextToken
          __typename
        }
        orders {
          items {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          nextToken
          __typename
        }
        stripeCustomerId
        owner
        createdAt
        updatedAt
        __typename
      }
      stripeCustomerId
      invoiceNumber
      invoiceId
      receiptNumber
      cart {
        id
        createdAt
        order {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        artOrders {
          items {
            id
            createdAt
            orderID
            email
            dpi
            length
            width
            resolution_length
            resolution_width
            paper
            frame
            moulding
            moulding_finish
            mount
            total
            tax
            updatedAt
            cartArtOrdersId
            artOrderArtId
            __typename
          }
          nextToken
          __typename
        }
        email
        status
        cost_total
        updatedAt
        cartOrderId
        __typename
      }
      email
      status
      cost_total
      cost_taxes
      cost_shipping
      couponId
      coupon_amount_off
      coupon_name
      discountId
      discount_amount
      promotionID
      promotion_code
      fulfillment_tracking_id
      fulfillment_method
      fulfillment_status
      fulfillment_createdAt
      fulfillment_updatedAt
      fulfillment_completedAt
      billing_name
      billing_address
      billing_address2
      billing_city
      billing_state
      billing_zip
      billing_country
      shipping_name
      shipping_address
      shipping_address2
      shipping_city
      shipping_state
      shipping_zip
      shipping_country
      shipping_phone
      notes
      vendor
      order_source
      currency
      cancel
      updatedAt
      userOrdersId
      orderCartId
      __typename
    }
    artOrders {
      items {
        id
        createdAt
        cart {
          id
          createdAt
          order {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          artOrders {
            nextToken
            __typename
          }
          email
          status
          cost_total
          updatedAt
          cartOrderId
          __typename
        }
        orderID
        art {
          id
          userId
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          title
          inputImage
          s3Image {
            bucket
            region
            key
            __typename
          }
          prompt
          revisedPrompt
          subject
          subjectText
          subOption
          styles
          stylesText
          color
          colorText
          medium
          mediumText
          model
          feeling
          feelingText
          like
          approve
          deleted
          updatedAt
          __typename
        }
        email
        file {
          bucket
          region
          key
          __typename
        }
        dpi
        length
        width
        resolution_length
        resolution_width
        paper
        frame
        moulding
        moulding_finish
        mount
        total
        tax
        updatedAt
        cartArtOrdersId
        artOrderArtId
        __typename
      }
      nextToken
      __typename
    }
    email
    status
    cost_total
    updatedAt
    cartOrderId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCartMutationVariables,
  APITypes.UpdateCartMutation
>;
export const deleteCart = /* GraphQL */ `mutation DeleteCart(
  $input: DeleteCartInput!
  $condition: ModelCartConditionInput
) {
  deleteCart(input: $input, condition: $condition) {
    id
    createdAt
    order {
      id
      createdAt
      user {
        id
        email
        username
        emailVerified
        identityId
        credits
        boughtCredits
        creditPurchases {
          items {
            id
            createdAt
            creditAmount
            checkoutSessionId
            paymentIntentId
            owner
            updatedAt
            userCreditPurchasesId
            __typename
          }
          nextToken
          __typename
        }
        orders {
          items {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          nextToken
          __typename
        }
        stripeCustomerId
        owner
        createdAt
        updatedAt
        __typename
      }
      stripeCustomerId
      invoiceNumber
      invoiceId
      receiptNumber
      cart {
        id
        createdAt
        order {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        artOrders {
          items {
            id
            createdAt
            orderID
            email
            dpi
            length
            width
            resolution_length
            resolution_width
            paper
            frame
            moulding
            moulding_finish
            mount
            total
            tax
            updatedAt
            cartArtOrdersId
            artOrderArtId
            __typename
          }
          nextToken
          __typename
        }
        email
        status
        cost_total
        updatedAt
        cartOrderId
        __typename
      }
      email
      status
      cost_total
      cost_taxes
      cost_shipping
      couponId
      coupon_amount_off
      coupon_name
      discountId
      discount_amount
      promotionID
      promotion_code
      fulfillment_tracking_id
      fulfillment_method
      fulfillment_status
      fulfillment_createdAt
      fulfillment_updatedAt
      fulfillment_completedAt
      billing_name
      billing_address
      billing_address2
      billing_city
      billing_state
      billing_zip
      billing_country
      shipping_name
      shipping_address
      shipping_address2
      shipping_city
      shipping_state
      shipping_zip
      shipping_country
      shipping_phone
      notes
      vendor
      order_source
      currency
      cancel
      updatedAt
      userOrdersId
      orderCartId
      __typename
    }
    artOrders {
      items {
        id
        createdAt
        cart {
          id
          createdAt
          order {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          artOrders {
            nextToken
            __typename
          }
          email
          status
          cost_total
          updatedAt
          cartOrderId
          __typename
        }
        orderID
        art {
          id
          userId
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          title
          inputImage
          s3Image {
            bucket
            region
            key
            __typename
          }
          prompt
          revisedPrompt
          subject
          subjectText
          subOption
          styles
          stylesText
          color
          colorText
          medium
          mediumText
          model
          feeling
          feelingText
          like
          approve
          deleted
          updatedAt
          __typename
        }
        email
        file {
          bucket
          region
          key
          __typename
        }
        dpi
        length
        width
        resolution_length
        resolution_width
        paper
        frame
        moulding
        moulding_finish
        mount
        total
        tax
        updatedAt
        cartArtOrdersId
        artOrderArtId
        __typename
      }
      nextToken
      __typename
    }
    email
    status
    cost_total
    updatedAt
    cartOrderId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCartMutationVariables,
  APITypes.DeleteCartMutation
>;
export const createArtOrder = /* GraphQL */ `mutation CreateArtOrder(
  $input: CreateArtOrderInput!
  $condition: ModelArtOrderConditionInput
) {
  createArtOrder(input: $input, condition: $condition) {
    id
    createdAt
    cart {
      id
      createdAt
      order {
        id
        createdAt
        user {
          id
          email
          username
          emailVerified
          identityId
          credits
          boughtCredits
          creditPurchases {
            nextToken
            __typename
          }
          orders {
            nextToken
            __typename
          }
          stripeCustomerId
          owner
          createdAt
          updatedAt
          __typename
        }
        stripeCustomerId
        invoiceNumber
        invoiceId
        receiptNumber
        cart {
          id
          createdAt
          order {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          artOrders {
            nextToken
            __typename
          }
          email
          status
          cost_total
          updatedAt
          cartOrderId
          __typename
        }
        email
        status
        cost_total
        cost_taxes
        cost_shipping
        couponId
        coupon_amount_off
        coupon_name
        discountId
        discount_amount
        promotionID
        promotion_code
        fulfillment_tracking_id
        fulfillment_method
        fulfillment_status
        fulfillment_createdAt
        fulfillment_updatedAt
        fulfillment_completedAt
        billing_name
        billing_address
        billing_address2
        billing_city
        billing_state
        billing_zip
        billing_country
        shipping_name
        shipping_address
        shipping_address2
        shipping_city
        shipping_state
        shipping_zip
        shipping_country
        shipping_phone
        notes
        vendor
        order_source
        currency
        cancel
        updatedAt
        userOrdersId
        orderCartId
        __typename
      }
      artOrders {
        items {
          id
          createdAt
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          orderID
          art {
            id
            userId
            createdAt
            title
            inputImage
            prompt
            revisedPrompt
            subject
            subjectText
            subOption
            styles
            stylesText
            color
            colorText
            medium
            mediumText
            model
            feeling
            feelingText
            like
            approve
            deleted
            updatedAt
            __typename
          }
          email
          file {
            bucket
            region
            key
            __typename
          }
          dpi
          length
          width
          resolution_length
          resolution_width
          paper
          frame
          moulding
          moulding_finish
          mount
          total
          tax
          updatedAt
          cartArtOrdersId
          artOrderArtId
          __typename
        }
        nextToken
        __typename
      }
      email
      status
      cost_total
      updatedAt
      cartOrderId
      __typename
    }
    orderID
    art {
      id
      userId
      createdAt
      user {
        id
        email
        username
        emailVerified
        identityId
        credits
        boughtCredits
        creditPurchases {
          items {
            id
            createdAt
            creditAmount
            checkoutSessionId
            paymentIntentId
            owner
            updatedAt
            userCreditPurchasesId
            __typename
          }
          nextToken
          __typename
        }
        orders {
          items {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          nextToken
          __typename
        }
        stripeCustomerId
        owner
        createdAt
        updatedAt
        __typename
      }
      title
      inputImage
      s3Image {
        bucket
        region
        key
        __typename
      }
      prompt
      revisedPrompt
      subject
      subjectText
      subOption
      styles
      stylesText
      color
      colorText
      medium
      mediumText
      model
      feeling
      feelingText
      like
      approve
      deleted
      updatedAt
      __typename
    }
    email
    file {
      bucket
      region
      key
      __typename
    }
    dpi
    length
    width
    resolution_length
    resolution_width
    paper
    frame
    moulding
    moulding_finish
    mount
    total
    tax
    updatedAt
    cartArtOrdersId
    artOrderArtId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateArtOrderMutationVariables,
  APITypes.CreateArtOrderMutation
>;
export const updateArtOrder = /* GraphQL */ `mutation UpdateArtOrder(
  $input: UpdateArtOrderInput!
  $condition: ModelArtOrderConditionInput
) {
  updateArtOrder(input: $input, condition: $condition) {
    id
    createdAt
    cart {
      id
      createdAt
      order {
        id
        createdAt
        user {
          id
          email
          username
          emailVerified
          identityId
          credits
          boughtCredits
          creditPurchases {
            nextToken
            __typename
          }
          orders {
            nextToken
            __typename
          }
          stripeCustomerId
          owner
          createdAt
          updatedAt
          __typename
        }
        stripeCustomerId
        invoiceNumber
        invoiceId
        receiptNumber
        cart {
          id
          createdAt
          order {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          artOrders {
            nextToken
            __typename
          }
          email
          status
          cost_total
          updatedAt
          cartOrderId
          __typename
        }
        email
        status
        cost_total
        cost_taxes
        cost_shipping
        couponId
        coupon_amount_off
        coupon_name
        discountId
        discount_amount
        promotionID
        promotion_code
        fulfillment_tracking_id
        fulfillment_method
        fulfillment_status
        fulfillment_createdAt
        fulfillment_updatedAt
        fulfillment_completedAt
        billing_name
        billing_address
        billing_address2
        billing_city
        billing_state
        billing_zip
        billing_country
        shipping_name
        shipping_address
        shipping_address2
        shipping_city
        shipping_state
        shipping_zip
        shipping_country
        shipping_phone
        notes
        vendor
        order_source
        currency
        cancel
        updatedAt
        userOrdersId
        orderCartId
        __typename
      }
      artOrders {
        items {
          id
          createdAt
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          orderID
          art {
            id
            userId
            createdAt
            title
            inputImage
            prompt
            revisedPrompt
            subject
            subjectText
            subOption
            styles
            stylesText
            color
            colorText
            medium
            mediumText
            model
            feeling
            feelingText
            like
            approve
            deleted
            updatedAt
            __typename
          }
          email
          file {
            bucket
            region
            key
            __typename
          }
          dpi
          length
          width
          resolution_length
          resolution_width
          paper
          frame
          moulding
          moulding_finish
          mount
          total
          tax
          updatedAt
          cartArtOrdersId
          artOrderArtId
          __typename
        }
        nextToken
        __typename
      }
      email
      status
      cost_total
      updatedAt
      cartOrderId
      __typename
    }
    orderID
    art {
      id
      userId
      createdAt
      user {
        id
        email
        username
        emailVerified
        identityId
        credits
        boughtCredits
        creditPurchases {
          items {
            id
            createdAt
            creditAmount
            checkoutSessionId
            paymentIntentId
            owner
            updatedAt
            userCreditPurchasesId
            __typename
          }
          nextToken
          __typename
        }
        orders {
          items {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          nextToken
          __typename
        }
        stripeCustomerId
        owner
        createdAt
        updatedAt
        __typename
      }
      title
      inputImage
      s3Image {
        bucket
        region
        key
        __typename
      }
      prompt
      revisedPrompt
      subject
      subjectText
      subOption
      styles
      stylesText
      color
      colorText
      medium
      mediumText
      model
      feeling
      feelingText
      like
      approve
      deleted
      updatedAt
      __typename
    }
    email
    file {
      bucket
      region
      key
      __typename
    }
    dpi
    length
    width
    resolution_length
    resolution_width
    paper
    frame
    moulding
    moulding_finish
    mount
    total
    tax
    updatedAt
    cartArtOrdersId
    artOrderArtId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateArtOrderMutationVariables,
  APITypes.UpdateArtOrderMutation
>;
export const deleteArtOrder = /* GraphQL */ `mutation DeleteArtOrder(
  $input: DeleteArtOrderInput!
  $condition: ModelArtOrderConditionInput
) {
  deleteArtOrder(input: $input, condition: $condition) {
    id
    createdAt
    cart {
      id
      createdAt
      order {
        id
        createdAt
        user {
          id
          email
          username
          emailVerified
          identityId
          credits
          boughtCredits
          creditPurchases {
            nextToken
            __typename
          }
          orders {
            nextToken
            __typename
          }
          stripeCustomerId
          owner
          createdAt
          updatedAt
          __typename
        }
        stripeCustomerId
        invoiceNumber
        invoiceId
        receiptNumber
        cart {
          id
          createdAt
          order {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          artOrders {
            nextToken
            __typename
          }
          email
          status
          cost_total
          updatedAt
          cartOrderId
          __typename
        }
        email
        status
        cost_total
        cost_taxes
        cost_shipping
        couponId
        coupon_amount_off
        coupon_name
        discountId
        discount_amount
        promotionID
        promotion_code
        fulfillment_tracking_id
        fulfillment_method
        fulfillment_status
        fulfillment_createdAt
        fulfillment_updatedAt
        fulfillment_completedAt
        billing_name
        billing_address
        billing_address2
        billing_city
        billing_state
        billing_zip
        billing_country
        shipping_name
        shipping_address
        shipping_address2
        shipping_city
        shipping_state
        shipping_zip
        shipping_country
        shipping_phone
        notes
        vendor
        order_source
        currency
        cancel
        updatedAt
        userOrdersId
        orderCartId
        __typename
      }
      artOrders {
        items {
          id
          createdAt
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          orderID
          art {
            id
            userId
            createdAt
            title
            inputImage
            prompt
            revisedPrompt
            subject
            subjectText
            subOption
            styles
            stylesText
            color
            colorText
            medium
            mediumText
            model
            feeling
            feelingText
            like
            approve
            deleted
            updatedAt
            __typename
          }
          email
          file {
            bucket
            region
            key
            __typename
          }
          dpi
          length
          width
          resolution_length
          resolution_width
          paper
          frame
          moulding
          moulding_finish
          mount
          total
          tax
          updatedAt
          cartArtOrdersId
          artOrderArtId
          __typename
        }
        nextToken
        __typename
      }
      email
      status
      cost_total
      updatedAt
      cartOrderId
      __typename
    }
    orderID
    art {
      id
      userId
      createdAt
      user {
        id
        email
        username
        emailVerified
        identityId
        credits
        boughtCredits
        creditPurchases {
          items {
            id
            createdAt
            creditAmount
            checkoutSessionId
            paymentIntentId
            owner
            updatedAt
            userCreditPurchasesId
            __typename
          }
          nextToken
          __typename
        }
        orders {
          items {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          nextToken
          __typename
        }
        stripeCustomerId
        owner
        createdAt
        updatedAt
        __typename
      }
      title
      inputImage
      s3Image {
        bucket
        region
        key
        __typename
      }
      prompt
      revisedPrompt
      subject
      subjectText
      subOption
      styles
      stylesText
      color
      colorText
      medium
      mediumText
      model
      feeling
      feelingText
      like
      approve
      deleted
      updatedAt
      __typename
    }
    email
    file {
      bucket
      region
      key
      __typename
    }
    dpi
    length
    width
    resolution_length
    resolution_width
    paper
    frame
    moulding
    moulding_finish
    mount
    total
    tax
    updatedAt
    cartArtOrdersId
    artOrderArtId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteArtOrderMutationVariables,
  APITypes.DeleteArtOrderMutation
>;
export const createArt = /* GraphQL */ `mutation CreateArt(
  $input: CreateArtInput!
  $condition: ModelArtConditionInput
) {
  createArt(input: $input, condition: $condition) {
    id
    userId
    createdAt
    user {
      id
      email
      username
      emailVerified
      identityId
      credits
      boughtCredits
      creditPurchases {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          creditAmount
          checkoutSessionId
          paymentIntentId
          owner
          updatedAt
          userCreditPurchasesId
          __typename
        }
        nextToken
        __typename
      }
      orders {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      owner
      createdAt
      updatedAt
      __typename
    }
    title
    inputImage
    s3Image {
      bucket
      region
      key
      __typename
    }
    prompt
    revisedPrompt
    subject
    subjectText
    subOption
    styles
    stylesText
    color
    colorText
    medium
    mediumText
    model
    feeling
    feelingText
    like
    approve
    deleted
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateArtMutationVariables,
  APITypes.CreateArtMutation
>;
export const updateArt = /* GraphQL */ `mutation UpdateArt(
  $input: UpdateArtInput!
  $condition: ModelArtConditionInput
) {
  updateArt(input: $input, condition: $condition) {
    id
    userId
    createdAt
    user {
      id
      email
      username
      emailVerified
      identityId
      credits
      boughtCredits
      creditPurchases {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          creditAmount
          checkoutSessionId
          paymentIntentId
          owner
          updatedAt
          userCreditPurchasesId
          __typename
        }
        nextToken
        __typename
      }
      orders {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      owner
      createdAt
      updatedAt
      __typename
    }
    title
    inputImage
    s3Image {
      bucket
      region
      key
      __typename
    }
    prompt
    revisedPrompt
    subject
    subjectText
    subOption
    styles
    stylesText
    color
    colorText
    medium
    mediumText
    model
    feeling
    feelingText
    like
    approve
    deleted
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateArtMutationVariables,
  APITypes.UpdateArtMutation
>;
export const deleteArt = /* GraphQL */ `mutation DeleteArt(
  $input: DeleteArtInput!
  $condition: ModelArtConditionInput
) {
  deleteArt(input: $input, condition: $condition) {
    id
    userId
    createdAt
    user {
      id
      email
      username
      emailVerified
      identityId
      credits
      boughtCredits
      creditPurchases {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          creditAmount
          checkoutSessionId
          paymentIntentId
          owner
          updatedAt
          userCreditPurchasesId
          __typename
        }
        nextToken
        __typename
      }
      orders {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      owner
      createdAt
      updatedAt
      __typename
    }
    title
    inputImage
    s3Image {
      bucket
      region
      key
      __typename
    }
    prompt
    revisedPrompt
    subject
    subjectText
    subOption
    styles
    stylesText
    color
    colorText
    medium
    mediumText
    model
    feeling
    feelingText
    like
    approve
    deleted
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteArtMutationVariables,
  APITypes.DeleteArtMutation
>;
export const createUser = /* GraphQL */ `mutation CreateUser(
  $input: CreateUserInput!
  $condition: ModelUserConditionInput
) {
  createUser(input: $input, condition: $condition) {
    id
    email
    username
    emailVerified
    identityId
    credits
    boughtCredits
    creditPurchases {
      items {
        id
        createdAt
        user {
          id
          email
          username
          emailVerified
          identityId
          credits
          boughtCredits
          creditPurchases {
            nextToken
            __typename
          }
          orders {
            nextToken
            __typename
          }
          stripeCustomerId
          owner
          createdAt
          updatedAt
          __typename
        }
        creditAmount
        checkoutSessionId
        paymentIntentId
        owner
        updatedAt
        userCreditPurchasesId
        __typename
      }
      nextToken
      __typename
    }
    orders {
      items {
        id
        createdAt
        user {
          id
          email
          username
          emailVerified
          identityId
          credits
          boughtCredits
          creditPurchases {
            nextToken
            __typename
          }
          orders {
            nextToken
            __typename
          }
          stripeCustomerId
          owner
          createdAt
          updatedAt
          __typename
        }
        stripeCustomerId
        invoiceNumber
        invoiceId
        receiptNumber
        cart {
          id
          createdAt
          order {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          artOrders {
            nextToken
            __typename
          }
          email
          status
          cost_total
          updatedAt
          cartOrderId
          __typename
        }
        email
        status
        cost_total
        cost_taxes
        cost_shipping
        couponId
        coupon_amount_off
        coupon_name
        discountId
        discount_amount
        promotionID
        promotion_code
        fulfillment_tracking_id
        fulfillment_method
        fulfillment_status
        fulfillment_createdAt
        fulfillment_updatedAt
        fulfillment_completedAt
        billing_name
        billing_address
        billing_address2
        billing_city
        billing_state
        billing_zip
        billing_country
        shipping_name
        shipping_address
        shipping_address2
        shipping_city
        shipping_state
        shipping_zip
        shipping_country
        shipping_phone
        notes
        vendor
        order_source
        currency
        cancel
        updatedAt
        userOrdersId
        orderCartId
        __typename
      }
      nextToken
      __typename
    }
    stripeCustomerId
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const updateUser = /* GraphQL */ `mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    id
    email
    username
    emailVerified
    identityId
    credits
    boughtCredits
    creditPurchases {
      items {
        id
        createdAt
        user {
          id
          email
          username
          emailVerified
          identityId
          credits
          boughtCredits
          creditPurchases {
            nextToken
            __typename
          }
          orders {
            nextToken
            __typename
          }
          stripeCustomerId
          owner
          createdAt
          updatedAt
          __typename
        }
        creditAmount
        checkoutSessionId
        paymentIntentId
        owner
        updatedAt
        userCreditPurchasesId
        __typename
      }
      nextToken
      __typename
    }
    orders {
      items {
        id
        createdAt
        user {
          id
          email
          username
          emailVerified
          identityId
          credits
          boughtCredits
          creditPurchases {
            nextToken
            __typename
          }
          orders {
            nextToken
            __typename
          }
          stripeCustomerId
          owner
          createdAt
          updatedAt
          __typename
        }
        stripeCustomerId
        invoiceNumber
        invoiceId
        receiptNumber
        cart {
          id
          createdAt
          order {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          artOrders {
            nextToken
            __typename
          }
          email
          status
          cost_total
          updatedAt
          cartOrderId
          __typename
        }
        email
        status
        cost_total
        cost_taxes
        cost_shipping
        couponId
        coupon_amount_off
        coupon_name
        discountId
        discount_amount
        promotionID
        promotion_code
        fulfillment_tracking_id
        fulfillment_method
        fulfillment_status
        fulfillment_createdAt
        fulfillment_updatedAt
        fulfillment_completedAt
        billing_name
        billing_address
        billing_address2
        billing_city
        billing_state
        billing_zip
        billing_country
        shipping_name
        shipping_address
        shipping_address2
        shipping_city
        shipping_state
        shipping_zip
        shipping_country
        shipping_phone
        notes
        vendor
        order_source
        currency
        cancel
        updatedAt
        userOrdersId
        orderCartId
        __typename
      }
      nextToken
      __typename
    }
    stripeCustomerId
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserMutationVariables,
  APITypes.UpdateUserMutation
>;
export const deleteUser = /* GraphQL */ `mutation DeleteUser(
  $input: DeleteUserInput!
  $condition: ModelUserConditionInput
) {
  deleteUser(input: $input, condition: $condition) {
    id
    email
    username
    emailVerified
    identityId
    credits
    boughtCredits
    creditPurchases {
      items {
        id
        createdAt
        user {
          id
          email
          username
          emailVerified
          identityId
          credits
          boughtCredits
          creditPurchases {
            nextToken
            __typename
          }
          orders {
            nextToken
            __typename
          }
          stripeCustomerId
          owner
          createdAt
          updatedAt
          __typename
        }
        creditAmount
        checkoutSessionId
        paymentIntentId
        owner
        updatedAt
        userCreditPurchasesId
        __typename
      }
      nextToken
      __typename
    }
    orders {
      items {
        id
        createdAt
        user {
          id
          email
          username
          emailVerified
          identityId
          credits
          boughtCredits
          creditPurchases {
            nextToken
            __typename
          }
          orders {
            nextToken
            __typename
          }
          stripeCustomerId
          owner
          createdAt
          updatedAt
          __typename
        }
        stripeCustomerId
        invoiceNumber
        invoiceId
        receiptNumber
        cart {
          id
          createdAt
          order {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          artOrders {
            nextToken
            __typename
          }
          email
          status
          cost_total
          updatedAt
          cartOrderId
          __typename
        }
        email
        status
        cost_total
        cost_taxes
        cost_shipping
        couponId
        coupon_amount_off
        coupon_name
        discountId
        discount_amount
        promotionID
        promotion_code
        fulfillment_tracking_id
        fulfillment_method
        fulfillment_status
        fulfillment_createdAt
        fulfillment_updatedAt
        fulfillment_completedAt
        billing_name
        billing_address
        billing_address2
        billing_city
        billing_state
        billing_zip
        billing_country
        shipping_name
        shipping_address
        shipping_address2
        shipping_city
        shipping_state
        shipping_zip
        shipping_country
        shipping_phone
        notes
        vendor
        order_source
        currency
        cancel
        updatedAt
        userOrdersId
        orderCartId
        __typename
      }
      nextToken
      __typename
    }
    stripeCustomerId
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserMutationVariables,
  APITypes.DeleteUserMutation
>;
export const createSession = /* GraphQL */ `mutation CreateSession(
  $input: CreateSessionInput!
  $condition: ModelSessionConditionInput
) {
  createSession(input: $input, condition: $condition) {
    id
    createdAt
    user {
      id
      email
      username
      emailVerified
      identityId
      credits
      boughtCredits
      creditPurchases {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          creditAmount
          checkoutSessionId
          paymentIntentId
          owner
          updatedAt
          userCreditPurchasesId
          __typename
        }
        nextToken
        __typename
      }
      orders {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      owner
      createdAt
      updatedAt
      __typename
    }
    credentials {
      AccessKeyId
      Expiration
      SecretKey
      __typename
    }
    owner
    updatedAt
    sessionUserId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSessionMutationVariables,
  APITypes.CreateSessionMutation
>;
export const updateSession = /* GraphQL */ `mutation UpdateSession(
  $input: UpdateSessionInput!
  $condition: ModelSessionConditionInput
) {
  updateSession(input: $input, condition: $condition) {
    id
    createdAt
    user {
      id
      email
      username
      emailVerified
      identityId
      credits
      boughtCredits
      creditPurchases {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          creditAmount
          checkoutSessionId
          paymentIntentId
          owner
          updatedAt
          userCreditPurchasesId
          __typename
        }
        nextToken
        __typename
      }
      orders {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      owner
      createdAt
      updatedAt
      __typename
    }
    credentials {
      AccessKeyId
      Expiration
      SecretKey
      __typename
    }
    owner
    updatedAt
    sessionUserId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSessionMutationVariables,
  APITypes.UpdateSessionMutation
>;
export const deleteSession = /* GraphQL */ `mutation DeleteSession(
  $input: DeleteSessionInput!
  $condition: ModelSessionConditionInput
) {
  deleteSession(input: $input, condition: $condition) {
    id
    createdAt
    user {
      id
      email
      username
      emailVerified
      identityId
      credits
      boughtCredits
      creditPurchases {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          creditAmount
          checkoutSessionId
          paymentIntentId
          owner
          updatedAt
          userCreditPurchasesId
          __typename
        }
        nextToken
        __typename
      }
      orders {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      owner
      createdAt
      updatedAt
      __typename
    }
    credentials {
      AccessKeyId
      Expiration
      SecretKey
      __typename
    }
    owner
    updatedAt
    sessionUserId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSessionMutationVariables,
  APITypes.DeleteSessionMutation
>;
export const createCreditPurchase = /* GraphQL */ `mutation CreateCreditPurchase(
  $input: CreateCreditPurchaseInput!
  $condition: ModelCreditPurchaseConditionInput
) {
  createCreditPurchase(input: $input, condition: $condition) {
    id
    createdAt
    user {
      id
      email
      username
      emailVerified
      identityId
      credits
      boughtCredits
      creditPurchases {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          creditAmount
          checkoutSessionId
          paymentIntentId
          owner
          updatedAt
          userCreditPurchasesId
          __typename
        }
        nextToken
        __typename
      }
      orders {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      owner
      createdAt
      updatedAt
      __typename
    }
    creditAmount
    checkoutSessionId
    paymentIntentId
    owner
    updatedAt
    userCreditPurchasesId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCreditPurchaseMutationVariables,
  APITypes.CreateCreditPurchaseMutation
>;
export const updateCreditPurchase = /* GraphQL */ `mutation UpdateCreditPurchase(
  $input: UpdateCreditPurchaseInput!
  $condition: ModelCreditPurchaseConditionInput
) {
  updateCreditPurchase(input: $input, condition: $condition) {
    id
    createdAt
    user {
      id
      email
      username
      emailVerified
      identityId
      credits
      boughtCredits
      creditPurchases {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          creditAmount
          checkoutSessionId
          paymentIntentId
          owner
          updatedAt
          userCreditPurchasesId
          __typename
        }
        nextToken
        __typename
      }
      orders {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      owner
      createdAt
      updatedAt
      __typename
    }
    creditAmount
    checkoutSessionId
    paymentIntentId
    owner
    updatedAt
    userCreditPurchasesId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCreditPurchaseMutationVariables,
  APITypes.UpdateCreditPurchaseMutation
>;
export const deleteCreditPurchase = /* GraphQL */ `mutation DeleteCreditPurchase(
  $input: DeleteCreditPurchaseInput!
  $condition: ModelCreditPurchaseConditionInput
) {
  deleteCreditPurchase(input: $input, condition: $condition) {
    id
    createdAt
    user {
      id
      email
      username
      emailVerified
      identityId
      credits
      boughtCredits
      creditPurchases {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          creditAmount
          checkoutSessionId
          paymentIntentId
          owner
          updatedAt
          userCreditPurchasesId
          __typename
        }
        nextToken
        __typename
      }
      orders {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      owner
      createdAt
      updatedAt
      __typename
    }
    creditAmount
    checkoutSessionId
    paymentIntentId
    owner
    updatedAt
    userCreditPurchasesId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCreditPurchaseMutationVariables,
  APITypes.DeleteCreditPurchaseMutation
>;
export const createGiftCardPurchase = /* GraphQL */ `mutation CreateGiftCardPurchase(
  $input: CreateGiftCardPurchaseInput!
  $condition: ModelGiftCardPurchaseConditionInput
) {
  createGiftCardPurchase(input: $input, condition: $condition) {
    id
    createdAt
    originalBalance
    couponId
    couponAmountOff
    couponCurrency
    couponName
    couponDuration
    couponMaxRedemptions
    promotionCode
    promotionID
    checkoutSessionId
    paymentIntentId
    recipientEmail
    customMessage
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateGiftCardPurchaseMutationVariables,
  APITypes.CreateGiftCardPurchaseMutation
>;
export const updateGiftCardPurchase = /* GraphQL */ `mutation UpdateGiftCardPurchase(
  $input: UpdateGiftCardPurchaseInput!
  $condition: ModelGiftCardPurchaseConditionInput
) {
  updateGiftCardPurchase(input: $input, condition: $condition) {
    id
    createdAt
    originalBalance
    couponId
    couponAmountOff
    couponCurrency
    couponName
    couponDuration
    couponMaxRedemptions
    promotionCode
    promotionID
    checkoutSessionId
    paymentIntentId
    recipientEmail
    customMessage
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateGiftCardPurchaseMutationVariables,
  APITypes.UpdateGiftCardPurchaseMutation
>;
export const deleteGiftCardPurchase = /* GraphQL */ `mutation DeleteGiftCardPurchase(
  $input: DeleteGiftCardPurchaseInput!
  $condition: ModelGiftCardPurchaseConditionInput
) {
  deleteGiftCardPurchase(input: $input, condition: $condition) {
    id
    createdAt
    originalBalance
    couponId
    couponAmountOff
    couponCurrency
    couponName
    couponDuration
    couponMaxRedemptions
    promotionCode
    promotionID
    checkoutSessionId
    paymentIntentId
    recipientEmail
    customMessage
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteGiftCardPurchaseMutationVariables,
  APITypes.DeleteGiftCardPurchaseMutation
>;
